/**
 * ClientEditDialog – client settings editing dialog built on BaseDialog (Material Tailwind).
 * @see https://www.material-tailwind.com/docs/react/dialog
 */

import React, { useEffect } from 'react'
import { BaseDialog, IBaseDialogProps } from '../base-components/BaseDialog'

type ICustomerSelectProps = Omit<IBaseDialogProps<string>, 'id' | 'onClose' | 'headerContent' | 'bodyContent' | 'footerContent'> & {
    id: string
    onClose: () => void
}

// {
//     id,
//     showDialog,
//     onClose,
//     onSave,
//     headerContent,
//     bodyContent,
//     footerContent,
//     saveLabel = 'Save',
//     cancelLabel = 'Cancel',
//     hideFooter = false,
//     saveHidden = false,
//     saveDisabled = false,
//     className = '',
// }

export function ClientEditDialog(props: ICustomerSelectProps) {

    console.log('ClientEditDialog', props)

    const [data, setData] = React.useState<any>(null)

    const getData = async (): Promise<boolean> => {
        const response = await fetch('api/client_settings.php?id=' + props.id)

        const json = await response.json()

        setData(json)
        console.log(json)
        return true
    }

    useEffect(() => {
        void getData()
    }, [])

    return (
        <BaseDialog
            {...props}
            headerContent={
                <div>Dialog header {data?.idx ?? '0'}</div>
            }
            bodyContent={
                <div>Dialog body</div>
            }
        // footerContent={
        //     <div>Dialog footer</div>
        // }
        ></BaseDialog>
    )
}
